import { styled } from '@mui/material/styles';
import { Box, css, Typography } from '@mui/material';
import { GRAY, WHITE } from 'constants/colors';

export const Section = styled(Box)`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(100px, auto));
  grid-gap: 10px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid ${GRAY};
  border-radius: 4px;
`;

export const Route = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTravelMovements'
})<{ isTravelMovements?: boolean }>`
  position: relative;
  display: flex;
  gap: 20px;
  margin-bottom: ${({ isTravelMovements }) =>
    isTravelMovements ? '24px' : '30px'};
  padding: 10px;
  border: 1px solid ${GRAY};
  border-radius: 4px;
`;

export const Column = styled(Box)`
  position: relative;
  grid-column: span 1;
`;

export const Knob = css`
  content: '';
  position: absolute;
  left: -4px;
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  border: 1px solid ${GRAY};
  background-color: ${WHITE};
`;

export const VerticalLine = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isTravelMovements' &&
    prop !== '$last' &&
    prop !== 'isManual' &&
    prop !== 'isEditMode'
})<{
  isTravelMovements?: boolean;
  isManual?: boolean;
  $last?: boolean;
  isEditMode?: boolean;
}>`
  position: absolute;
  top: ${({ isManual, isTravelMovements }) =>
    !isManual ? (isTravelMovements ? '27px' : '17.5px') : '18px'};
  left: -20px;
  width: 1px;
  height: ${({ isManual, isTravelMovements, isEditMode }) =>
    !isManual
      ? isTravelMovements
        ? `calc(100% + ${isEditMode ? '70px' : '50px'})`
        : 'calc(100% + 32px)'
      : 'calc(100% + 34px)'};
  background-color: ${GRAY};

  &:before {
    ${Knob}
    top: 0;
  }

  ${({ $last }) =>
    $last &&
    `
    height: 0px;

    &:after {
      bottom: 0px;
    }
  `}
`;

export const Label = styled(Typography)`
  &:not(:first-of-type) {
    margin-top: 10px;
  }
`;

export const Text = styled('span')`
  display: block;
`;
